<template>
    <Breadcrumbs
        main="Liste des catégories de signalement"
        mains="Liste des catégories de signalement"
        title="Paramètres"
    />
    <div class="container-fluid">
        <div class="row">
            <ReportCategoryList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const ReportCategoryList = defineAsyncComponent(
    () => import('@/components/theme/report/ReportCategoryList.vue'),
);
</script>